export default __webpack_public_path__ + "fed86783211da57683f686ad6b173e56.png";